class FlashSnackbar {
  constructor($root) {
    if (!$root.length) return
    this.$root = $root

    this.$root.on('click', '.flash-snackbar__close-button', () => this.$root.hide())
  }
}

document.addEventListener('DOMContentLoaded', () => {
  return new FlashSnackbar($('.flash-snackbar'))
})
